import { useMemo, useState } from 'react';
import {
  OutputSnapshotVersionType,
  useInputDataOutputsQuery,
} from '@atlas-frontend/sdk';

export function useOutputDescription(
  valueDate: string,
  descriptionId?: string,
) {
  const [output, setOutput] = useState<OutputSnapshotVersionType['output']>();
  const { isLoading, data } = useInputDataOutputsQuery(
    { descriptionId: descriptionId ?? '', valueDate },
    {
      enabled: !!descriptionId,
    },
  );
  const options = useMemo(() => {
    const outputOptions =
      data?.map((output) => ({
        value: output.outputDescriptionId,
        label: `${output.outputDescriptionCode} - ${output.outputDescriptionName}`,
        output,
      })) ?? [];
    if (outputOptions.length === 1) {
      setOutput(outputOptions[0].output);
    }

    return outputOptions;
  }, [data]);

  return { data, isLoading, options, output, setOutput };
}
